angular.module('app').config(hotelContentsRouting);

function hotelContentsRouting($routeProvider) {
  $routeProvider
    .when('/hotel_contents', {
      pageTitle: 'HOTELS',
      template: '<hotel-contents-page></hotel-contents-page>',
      breadcrumb: {
        label: 'WEBSITES',
        parent: 'ng/websites',
        // ajs: true,
      },
      menu: 'websites',
      accessPermission: 'index_hotel_accountadmin',
      authReq: true,
    })
    .when('/hotel_contents/new', {
      pageTitle: 'ADD_CONTENT',
      template: '<hotel-content-page></hotel-content-page>',
      breadcrumb: {
        label: 'WEBSITES',
        parent: 'ng/websites',
        // ajs: true,
      },
      // breadcrumb: {
      //   label: 'HOTELS',
      //   parent: 'hotel_contents',
      // },
      menu: 'websites',
      accessPermission: 'create_hotel_accountadmin',
      authReq: true,
    })
    .when('/hotel_contents/:id', {
      pageTitle: 'CONTENT_OVERVIEW',
      template: '<hotel-content-page></hotel-content-page>',
      breadcrumb: {
        label: 'WEBSITES',
        parent: 'ng/websites',
        // ajs: true,
      },
      // breadcrumb: {
      //   label: 'HOTELS',
      //   parent: 'hotel_contents',
      // },
      menu: 'websites',
      accessPermission: 'show_hotel_accountadmin',
      authReq: true,
    });
}

hotelContentsRouting.$inject = ['$routeProvider'];
